/**
 * Dont forget to map new permissions to roles in role-permission.service
 */
export enum RolePermission {

  USERS_MODULE = 'USERS_MODULE',
  BLOCKS_MODULE = 'BLOCKS_MODULE',
  FINANCE_MODULE = 'FINANCE_MODULE',
  ANALYTICS_MODULE = 'ANALYTICS_MODULE',
  AD_UNITS_MODULE = 'AD_UNITS_MODULE',
  UNIT_REQUESTS_MODULE = 'UNIT_REQUESTS_MODULE',
  ADS_TXT_MODULE = 'ADS_TXT_MODULE',
  WIDGETS_MODULE = 'WIDGETS_MODULE',
  SUPPORT_MODULE = 'SUPPORT_MODULE',
  PUBLISHERS_MODULE = 'PUBLISHERS_MODULE',
  SITE_APPROVAL_MODULE = 'SITE_APPROVAL_MODULE',
  DEMAND_PARTNER_MODULE = 'DEMAND_PARTNER_MODULE',
  RB_FINANCE = 'RB_FINANCE',
  MAIN_DASH_FINANCE = 'MAIN_DASH_FINANCE',

  AD_UNITS_CREATE_UNIT = 'AD_UNITS_CREATE_UNIT',
  AD_UNIT_FINANCE = 'AD_UNIT_FINANCE',
  AD_UNIT_OPTIMIZATIONS = 'AD_UNIT_OPTIMIZATIONS',
  PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT = 'PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT',
  PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP = 'PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP',
  PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL = 'PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL',
  PUBLISHERS_ON_BOARDING_IO_STATUS = 'PUBLISHERS_ON_BOARDING_IO_STATUS',
  PUBLISHERS_OVERVIEW_PRICING = 'PUBLISHERS_OVERVIEW_PRICING',
  PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION = 'PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION',
  PUBLISHERS_PUBLISHERS_DFP_INFORMATION = 'PUBLISHERS_PUBLISHERS_DFP_INFORMATION',
  SITE_APPROVAL_TABLE_APPROVE_REJECT = 'SITE_APPROVAL_TABLE_APPROVE_REJECT',
  // enable selection of sales representative in add publisher modal
  SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION = 'SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION',
  SITE_APPROVAL_IAS_EXPORT_IMPORT = 'SITE_APPROVAL_IAS_EXPORT_IMPORT',
}



